import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import BannerSection from "./components/BannerSection";
import ProjectsSection from "./components/ProjectsSection";
import TeamSection from "./components/TeamSection";
import FoundersSection from "./components/FoundersSection";
import ProcessSection from "./components/ProcessSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import ProjectsPage from "./components/ProjectsPage";
import ProjectDetailPage from "./components/ProjectDetailPage";
import AmbitionPage from "./components/AmbitionPage";
import DesignPage from "./components/DesignPage";
import ExecutionPage from "./components/ExecutionPage";
import TeamPage from "./components/TeamPage";
import ContactPage from "./components/ContactPage";
import PrivacyPage from "./components/PrivacyPage";
import CookieConsent from "./components/CookieConsent";

const Home = () => {
  return (
    <div className="min-h-screen" style={{ background: '#0a0a0a' }}>
      <Header />
      <main>
        <HeroSection />
        <BannerSection />
        <ProjectsSection />
        <TeamSection />
        <FoundersSection />
        <ProcessSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

const PageWrapper = ({ children }) => (
  <div className="min-h-screen" style={{ background: '#0a0a0a' }}>
    <Header />
    {children}
    <Footer />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projecten" element={<PageWrapper><ProjectsPage /></PageWrapper>} />
          <Route path="/projecten/:slug" element={<PageWrapper><ProjectDetailPage /></PageWrapper>} />
          <Route path="/ambitiedocument" element={<PageWrapper><AmbitionPage /></PageWrapper>} />
          <Route path="/doordacht-design" element={<PageWrapper><DesignPage /></PageWrapper>} />
          <Route path="/uitvoering" element={<PageWrapper><ExecutionPage /></PageWrapper>} />
          <Route path="/team" element={<PageWrapper><TeamPage /></PageWrapper>} />
          <Route path="/contact" element={<PageWrapper><ContactPage /></PageWrapper>} />
          <Route path="/privacy" element={<PageWrapper><PrivacyPage /></PageWrapper>} />
          <Route path="/*" element={<Home />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
